// Dual-handle price range slider
function initPriceRangeSliders() {
    document.querySelectorAll('.facets-new__range-wrapper').forEach(function (wrapper) {
        // Avoid double-binding on re-render
        if (wrapper.dataset.sliderInit) return;
        wrapper.dataset.sliderInit = '1';

        const groupBody = wrapper.closest('.facets-new__group-body');
        if (!groupBody) return;
        const priceRange = groupBody.querySelector('price-range');
        if (!priceRange) return;

        const minRange = wrapper.querySelector('.facets-new__range-input--min');
        const maxRange = wrapper.querySelector('.facets-new__range-input--max');
        const numberInputs = priceRange.querySelectorAll('input[type="number"]');
        if (!minRange || !maxRange || numberInputs.length < 2) return;

        const minNumber = numberInputs[0];
        const maxNumber = numberInputs[1];
        const track = wrapper.querySelector('.facets-new__range-track');
        const rangeMax = parseFloat(maxRange.max) || 1;

        function updateFill() {
            const lo = parseFloat(minRange.value) || 0;
            const hi = parseFloat(maxRange.value) || rangeMax;
            const loPct = (lo / rangeMax * 100).toFixed(2) + '%';
            const hiPct = (hi / rangeMax * 100).toFixed(2) + '%';
            track.style.background = 'linear-gradient(to right, #E5E3D4 ' + loPct + ', #5FCE36 ' + loPct + ', #5FCE36 ' + hiPct + ', #E5E3D4 ' + hiPct + ')';
        }

        // Pre-initialize data-max/data-min so PriceRange.adjustToValidValues
        // never sees an unset attribute (which resolves to 0 and clamps the value).
        minNumber.setAttribute('data-max', rangeMax);
        maxNumber.setAttribute('data-min', 0);

        // Init slider positions from number inputs (already whole numbers from Liquid)
        minRange.value = minNumber.value !== '' ? minNumber.value : 0;
        maxRange.value = maxNumber.value !== '' ? maxNumber.value : rangeMax;
        updateFill();

        minRange.addEventListener('input', function () {
            if (parseFloat(minRange.value) > parseFloat(maxRange.value)) {
                minRange.value = maxRange.value;
            }
            minNumber.value = Math.round(parseFloat(minRange.value));
            // No dispatchEvent — the range input's 'input' event already bubbles
            // to the form and triggers debouncedOnSubmit.
            updateFill();
            minRange.style.zIndex = 5;
            maxRange.style.zIndex = 4;
        });

        maxRange.addEventListener('input', function () {
            if (parseFloat(maxRange.value) < parseFloat(minRange.value)) {
                maxRange.value = minRange.value;
            }
            maxNumber.value = Math.round(parseFloat(maxRange.value));
            updateFill();
            maxRange.style.zIndex = 5;
            minRange.style.zIndex = 4;
        });

        // Sync sliders when number inputs are edited manually
        minNumber.addEventListener('change', function () {
            if (minNumber.value !== '') minRange.value = Math.round(parseFloat(minNumber.value));
            updateFill();
        });

        maxNumber.addEventListener('change', function () {
            if (maxNumber.value !== '') maxRange.value = Math.round(parseFloat(maxNumber.value));
            updateFill();
        });
    });
}

document.addEventListener('DOMContentLoaded', initPriceRangeSliders);
document.addEventListener('facets:rendered', initPriceRangeSliders);

// Product card variant overflow (+N button)
(function () {
    function initVariantOverflow(container) {
        const items = Array.from(container.querySelectorAll('.variant-option'));
        const btn = container.querySelector('.product-card__variants-more');
        if (!btn || items.length < 2) return;

        const firstTop = Math.round(items[0].getBoundingClientRect().top);
        let cutIndex = -1;
        for (let i = 1; i < items.length; i++) {
            if (Math.round(items[i].getBoundingClientRect().top) > firstTop) {
                cutIndex = i;
                break;
            }
        }
        if (cutIndex < 0) return;

        if (cutIndex > 0) cutIndex = Math.max(1, cutIndex - 1);

        const toHide = items.slice(cutIndex);
        toHide.forEach(function (item) { item.hidden = true; });
        btn.textContent = '+' + toHide.length;
        btn.hidden = false;

        btn.addEventListener('click', function () {
            toHide.forEach(function (item) { item.hidden = false; });
            btn.hidden = true;
        }, { once: true });
    }

    function initAll() {
        document.querySelectorAll('.product-card__variants').forEach(initVariantOverflow);
    }

    function run() {
        requestAnimationFrame(function () { requestAnimationFrame(initAll); });
    }

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(run);
    } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }

    document.addEventListener('facets:rendered', run);
})();

// Product card image skeleton loader
(function () {
    function markLoaded(img) {
        img.classList.add('img-loaded');
        const area = img.closest('.product-card__image-area');
        if (area) area.classList.add('img-loaded');
    }

    function initImageSkeleton(root) {
        (root || document).querySelectorAll('.product-card__image').forEach(function (img) {
            if (img.complete && img.naturalWidth > 0) {
                markLoaded(img);
            } else {
                img.addEventListener('load', function () { markLoaded(img); }, { once: true });
                img.addEventListener('error', function () { markLoaded(img); }, { once: true });
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initImageSkeleton(); });
    } else {
        initImageSkeleton();
    }

    document.addEventListener('facets:rendered', function () { initImageSkeleton(); });
})();

// Product card variant switching
document.addEventListener('click', function (e) {
    const option = e.target.closest('.variant-option[data-variant-id]');
    if (!option) return;

    const card = option.closest('.product-card');
    if (!card) return;

    const variantId = option.dataset.variantId;

    card.querySelectorAll('.variant-card').forEach(function (vc) {
        vc.classList.remove('active');
    });

    const target = card.querySelector('.variant-card[data-variant-id="' + variantId + '"]');
    if (target) target.classList.add('active');
});